<template>
  <w-settings-content-template>
    <div slot="content">
      <el-row class="title-bar" type="flex" justify="space-between">
        <div class="title-h3">
          Agent 목록
        </div>
        <el-row type="flex" align="center">
          <el-button class="mr-r5" type="content" size="medium" :disabled="ondemandStatus || controlStatus" @click="exportExcel"><img src="@/assets/img/icons/excel.png" style="position:relative;top:3px;left:-2px">  엑셀출력</el-button>
          <w-header-search-button @click="showSearchTool = !showSearchTool"></w-header-search-button>
        </el-row>
      </el-row>
      <div :class="[ondemandStatus ? $style['ondemand-status-load-mask'] : '']">
        <el-table-wrapper v-loading="ondemandStatus || controlStatus" ref="serverObjTable" :data="tableData" :columns="columns" :show-search-tool="showSearchTool" :pagination="true" :show-custom-header="true"
          remote :total="total" @condition-change="onChangeTable" element-loading-spinner="none" element-loading-background="rgba(0, 0, 0, 0.0)">
          <template #agent-status-slot="scope">
            <span v-if="scope.row.runningStatus === 'running'" :class="[$style['server-agent-health'], $style['status-up']]"></span>
            <span v-else :class="[$style['server-agent-health'], ondemandStatus ? $style['status-wait'] : $style['status-down']]"></span>
          </template>
          <template #cpu-userate-slot="scope">
            <w-rsc-perf-event-progress-bar v-if="!isNull(scope.row.cpuUserate) && getStringtoNumber(scope.row.cpuUserate) >= 0" :perfRecords="scope.row" perfKey="cpuUserate" />
            <span v-else>{{ EMPTY_TEXT }}</span>
          </template>
          <template #mem-used-size-slot="scope">
            <span> {{ convertSlotValue(scope.row.memUsedSize) }}</span>
          </template>
          <template #disk-used-size-slot="scope">
            <span> {{ convertSlotValue(scope.row.directoryUsesize) }}</span>
          </template>
          <template #agent-control-slot="scope">
            <el-button style="width: 100%;" :disabled="ondemandStatus || controlStatus" @click="onClickAgentConrolSlot(scope.row)">
              <span v-if="scope.row.runningStatus === 'running'">중지</span>
              <span v-else>기동</span>
            </el-button>
          </template>
        </el-table-wrapper>
      </div>
    </div>
  </w-settings-content-template>
</template>

<script>
import WSettingsContentTemplate from '@/components/template/SettingsContentTemplate';
import { columnDefault } from '@/constants/table';
import { isNil, cloneDeep, forEach, isUndefined, isNull } from 'lodash';
import { EMPTY_TEXT, getValueAfterCheckEmpty } from '@/utils/string';
import { convertValuByUnit } from '@/utils/number';
import WRscPerfEventProgressBar from '@/components/progressbar/RscPerfEventProgressBar';
import OperationApi from '@/api/settings/common/operation-settings';
import msgUtil from '@/utils/message';
import { getDateToString } from '@/utils/date';
import { isEmpty } from '@/utils/basic';

export default {
  name: 'WServerAgent',
  components: {
    WSettingsContentTemplate,
    WRscPerfEventProgressBar,
  },
  props: {
    activeView: String,
  },
  data() {
    return {
      isNull,
      controlStatus: false,
      ondemandStatus: true,
      EMPTY_TEXT,
      total: null,
      showSearchTool: false,
      tableData: [],
      columnDefault,
      columns: [
        { prop: 'runningStatus', label: '상태', width: 80, scopedSlot: 'agent-status-slot' },
        { prop: 'objName', label: '대상명', sortable: true, searchable: true, remoteProp: 'o.obj_name' },
        { prop: 'ipaddress', label: 'IP', sortable: true, searchable: true, formatter: this.getTableValueAfterCheckEmpty, remoteProp: 'ipaddress' },
        { prop: 'osType', label: 'OS종류', sortable: true, searchable: true, formatter: this.getTableValueAfterCheckEmpty, remoteProp: 'objtype.objtype_name' },
        { prop: 'version', label: 'Agent 버전', formatter: this.getTableValueAfterCheckEmpty },
        { prop: 'installDatetime', label: '최근 설치 시각', width: 150, formatter: this.formatScheduleDatetime },
        { prop: 'installPath', label: '설치위치', formatter: this.getTableValueAfterCheckEmpty },
        { prop: 'cpuUserate', label: 'CPU (%)', scopedSlot: 'cpu-userate-slot' },
        { prop: 'memUsedSize', label: 'MEM (Byte)', scopedSlot: 'mem-used-size-slot' },
        { prop: 'directoryUsesize', label: 'DISK (Byte)', scopedSlot: 'disk-used-size-slot' },
        { label: '제어', width: 100, headerAlign: 'center', scopedSlot: 'agent-control-slot' },
      ],
    };
  },
  watch: {
    activeView: {
      handler() {
        if (this.activeView === this.$options.name) {
          this.$nextTick(() => {
            this.loadData();
          });
        }
      },
      immediate: true,
    },
  },
  methods: {
    /**
     * [서버 Agent 조회함수] agent 세션통신과 DB(statusDoc)데이터, obj 대상들을 조회한다.
     * @return {[type]} [description]
     * @author Song
     */
    loadData() {
      this.ondemandStatus = true;
      const tableParams = this.$refs.serverObjTable.getParameter();
      const params = {
        ...tableParams,
      };
      // 데이터 조회 (DB 쿼리만)
      OperationApi.getServerAgentInfoList(params).then((res) => {
        if (res.data.success) {
          this.tableData = res.data.data;
          this.total = res.data.total;

          const startMessage = this.$message({
            message: '실시간 Agent 상태를 조회중입니다.',
            duration: 0,
          });
          // 데이터 조회 (ondemand 요청 포함)
          OperationApi.getServerAgentHealthList(params).then((response) => {
            const onDemandList = response.data.data;
            forEach(onDemandList, (item) => {
              const targetList = this.tableData.find((re) => re.objId === item.objId);
              item.cpuUserate = isUndefined(targetList.cpuUserate) ? null : targetList.cpuUserate;
              item.memUsedSize = isUndefined(targetList.memUsedSize) ? null : targetList.memUsedSize;
            });
            this.tableData = onDemandList;
            this.total = response.data.total;
            // 결과 알림
            this.$message({
              message: '실시간 Agent 상태 조회가 완료되었습니다.',
              type: 'success',
            });
          }).catch(() => {
            // 결과 알림
            this.$message({
              message: '실시간 Agent 상태 조회를 실패하였습니다.',
              type: 'error',
            });
          }).finally(() => {
            startMessage.close();
            this.ondemandStatus = false;
          });
        }
      });
    },
    /**
     * Agent Server를 기동/중지 시키고 그에 따라 해당 장비를 다시 로드하여 대상 값만 변경해준다.
     * @return {[type]} [description]
     * @author Song
     */
    onClickAgentConrolSlot(row) {
      let targetMessage = null;
      const constrolType = row.runningStatus === 'running' ? '중지' : '기동';
      const verse = row.runningStatus === 'running' ? '를' : '을';
      const params = {
        executeType: row.runningStatus === 'running' ? 'AGENTSTOP' : 'AGENTRUN',
        targetList: [
          { objId: row.objId, objIp: row.ipaddress },
        ],
      };
      this.$confirm(...msgUtil.getCustomConfirmData(`Agent를 ${constrolType}하시겠습니까?`)).then(() => {
        targetMessage = this.$message({
          message: `서버 Agent ${constrolType} 중 입니다.`,
          duration: 0,
        });
        this.controlStatus = true;

        // 서버 agent를 제어 수행하며 리턴이 true일 경우 해당 row의 obj만 재로드 실시
        OperationApi.executeServerAgent(params).then((res) => {
          if (res.data.success) {
            const targetData = {
              objId: row.objId,
              // ipaddress: row.ipaddress,
            };
            // objId 전달 및 단일 getServerAgentHealthList 조회 후 해당 row만 데이터 교체 - (모든 대상을 다시 조회하는 건 비효율)
            OperationApi.getServerAgentHealthList(targetData).then((response) => {
              if (response.data.success) {
                const tableDataPre = cloneDeep(this.tableData);
                const targetIndex = tableDataPre.findIndex((item) => item.objId === row.objId);
                this.tableData = [];
                // 결과
                this.$nextTick(() => {
                  tableDataPre[targetIndex] = response.data.data[0];
                  this.tableData = tableDataPre;
                  this.controlStatus = false;
                  targetMessage.close(); // 메시지 삭제
                  // 수행 성공 유무 메시지를 제공
                  if (res.data.data.indexOf('시작되었습니다') >= 0 || res.data.data.indexOf('멈추었습니다') >= 0 || res.data.data.indexOf('Run') >= 0 ||
                  res.data.data.indexOf('Stop') >= 0) {
                    this.$message(msgUtil.getCustomResultMsgData(`서버 Agent ${constrolType}${verse} 완료하였습니다.`, true));
                  } else {
                    this.$message(msgUtil.getCustomResultMsgData(`서버 Agent ${constrolType}에 실패하였습니다.`, false));
                  }
                });
              }
            }).catch(() => {
              targetMessage.close();
              this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '서버 Agent', false));
              this.controlStatus = false;
            });
          }
        }).catch(() => {
          targetMessage.close();
          this.$message(msgUtil.getCustomResultMsgData(`서버 Agent ${constrolType}에 실패하였습니다.`, false));
          this.controlStatus = false;
        });
      });
    },
    /**
     * 서버 Agent 테이블 데이터를 엑셀에 출력한다.
     * @return {[type]} [description]
     * @author Song
     */
    exportExcel() {
      OperationApi.exportServerAgentHealthList();
    },
    convertSlotValue(value) {
      return isNil(value) ? EMPTY_TEXT : convertValuByUnit(value, null);
    },
    getTableValueAfterCheckEmpty(row, column, value) {
      return getValueAfterCheckEmpty(value);
    },
    getStringtoNumber(value) {
      return Number(value);
    },
    formatScheduleDatetime(row, column, value) {
      if (isEmpty(value)) {
        return EMPTY_TEXT;
      }
      return getDateToString(value);
    },
    onChangeTable() {
      this.loadData();
    },
  },
};
</script>

<style module lang="scss">
.server-agent-health {
  display: inline-block;
  width: 14px;
  height: 14px;
  border-radius: 50%;
}
.status-up {
  background-color: rgb(92, 189, 95);
}
.status-down {
  background-color: rgb(255, 78, 94);
}
.status-wait {
  background-color: #b1aaab;
}
.ondemand-status-load-mask {
  z-index: 100;
}
</style>



// WEBPACK FOOTER //
// src/views/settings/operation/HealthCheck/ServerAgent/index.vue